import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function SettingsHubRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.SettingsHub', {
		url: '/admin/settings/hub',
		controllerAs: 'vm',
		controller: SettingsHubCtrl,
		templateUrl: '/ng/hub/Settings/Hub/SettingsHubCtrl.html?' + window.BUILD,
		permission: ['instance_settings'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/Settings/Hub/SettingsHubCtrl.css'),
			$title: () => 'Hub Settings',
			settings: ApiResourcify.endpoint('/config/search?scopes=hub'),
		},
	});
}

export class SettingsHubCtrl {
	constructor(settings, Identity) {
		'ngInject';
		this.searchText = '';
		this.isUserSuperAdmin = Identity.isSuperadmin();
		this.allSettings = settings;
		// add searchable text for all settings
		this.allSettings.forEach(setting => {
			setting.searchLower = `${setting.code} ${setting.help_text} ${setting.name}`.toLocaleLowerCase();
		});
	}

	$onInit() {
		this.filter();
	}

	displaySettings(settings) {
		// organizes each setting into its corresponding section heading. Settings are displayed beneath the appropriate heading
		this.settingsBySection = {};
		settings.forEach(setting => {
			if (!this.settingsBySection.hasOwnProperty(setting.section_name)) {
				this.settingsBySection[setting.section_name] = [];
			}
			this.settingsBySection[setting.section_name].push(setting);
		});
		this.sectionHeadings = Object.keys(this.settingsBySection);
	}

	/**
	 * E.g., returns `true` if the `item.searchLower` is 'hello how are you today' and `searchWords` is ['hello', 'today']
	 * This is a direct copy of the function in `searchAndChooseComponent.js`
	 * @param item
	 *  @property searchLower String  `searchWords` will be searched for inside this text
	 * @param searchWords Array  a list of words to search
	 * @returns Boolean  `true` if all `searchWords` are found in `item.searchLower`
	 */
	itemMatchesAllWords(item, searchWords) {
		let itemText = item.searchLower;
		let lastLength = itemText.length;
		for (const word of searchWords) {
			itemText = itemText.replace(word, '');
			if (itemText.length === lastLength) {
				return false;
			}
			lastLength = itemText.length;
		}
		return true;
	}

	/**
	 * Decides which settings to show based on the user's search text
	 */
	filter() {
		const searchWords = this.searchText.toLocaleLowerCase().split(/\s+/);
		if (this.searchText === '') {
			this.displaySettings(this.allSettings);
		} else {
			const displayedItems = [];
			this.allSettings.some(item => {
				if (this.itemMatchesAllWords(item, searchWords)) {
					// matches filter
					displayedItems.push(item);
				}
			});
			this.displaySettings(displayedItems);
		}
	}
}
